import { useContext } from 'react';
import SessionAuthContext from 'Src/common/context/sessionAuth';

const useSessionAuth = () => useContext(SessionAuthContext);

export default useSessionAuth;
